import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { Text } from 'foundations-components/components/Text';
import { CustomerFacingProducts, HUBSPOT_FREE } from '../ProductTypes';
import RolloutFeatureGroups from './RolloutFeatureGroups';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getHubFromProductName = productName => {
  if (productName.startsWith('crm-suite')) {
    return I18n.text(`app.hubs.customerPlatform`);
  }
  if (productName.startsWith('core-seats')) {
    return I18n.text(`app.hubs.smart-crm`);
  }
  const hub = productName.split('-')[0];
  return I18n.text(`app.hubs.${hub}`);
};
const RolloutProductUpdateProducts = ({
  rolloutProducts,
  featureGroups
}) => {
  const renderProducts = products => {
    if (products.includes(HUBSPOT_FREE)) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.products.hubspot-free"
      });
    }
    const hubs = [...new Set(products.filter(product => CustomerFacingProducts.has(product)).map(product => getHubFromProductName(product)))];
    return hubs.length ? /*#__PURE__*/_jsx("span", {
      children: hubs.join(', ')
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: "--"
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderProducts(rolloutProducts), /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(Text, {
        color: "text-core-subtle",
        as: "span",
        children: /*#__PURE__*/_jsx(RolloutFeatureGroups, {
          featureGroups: featureGroups
        })
      })
    })]
  });
};
export default RolloutProductUpdateProducts;